module.exports = __webpack_public_path__ + "zmenseni-prsou_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_1_before.jpg
// module id = 1278
// module chunks = 0